import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import { useAuth } from '../hooks/useAuth';
import { createAuthenticatedAxios } from '../utils/auth';
import '../styles.css';

function Layout({ children }) {
  const { isAuthenticated, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubscriber, setIsSubscriber] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isWarmTheme, setIsWarmTheme] = useState(() => localStorage.getItem('td-theme') === 'warm');

  useEffect(() => {
    document.body.classList.toggle('theme-warm', isWarmTheme);
  }, [isWarmTheme]);

  const toggleTheme = () => {
    setIsWarmTheme(prev => {
      const next = !prev;
      localStorage.setItem('td-theme', next ? 'warm' : 'default');
      return next;
    });
  };

  useEffect(() => {
    const checkUserStatus = async () => {
      if (!isAuthenticated) {
        setIsSubscriber(false);
        setIsAdmin(false);
        return;
      }

      try {
        const axios = createAuthenticatedAxios(logout);
        const [subscriptionResponse, userResponse] = await Promise.all([
          axios.get('/api/subscription/status'),
          axios.get('/api/user')
        ]);
        
        setIsSubscriber(subscriptionResponse.data.isPremium);
        setIsAdmin(userResponse.data.is_admin || false);
      } catch (error) {
        console.error('Error checking user status:', error);
        // If there's an auth error, the interceptor will handle logout
      }
    };

    checkUserStatus();
  }, [isAuthenticated, logout]);

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div>
      {/* Header */}
      <header className="app-header">
        <div className="header-container">
          {/* Logo/Brand */}
          <div className="header-logo">
            <h1 onClick={() => window.location.href = '/'}>
              True Devotion
            </h1>
            {isSubscriber && (
              <span 
                title="Premium Subscriber"
              >
                👑
              </span>
            )}
          </div>

          {/* Menu Button */}
          <div className="menu-container">
            <button
              className="theme-toggle-btn"
              onClick={toggleTheme}
              title="Try the warm theme (experimental)"
            >
              {isWarmTheme ? 'Warm theme: on' : 'Warm theme'}
            </button>
            <button
              className="menu-button"
              onClick={toggleMenu}
            >
              Menu
            </button>
            
            {/* Dropdown Menu */}
            {isMenuOpen && (
              <div className="dropdown-menu">
                {isAuthenticated && (
                  <>
                    <a 
                      href="/question-of-the-day"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Question of the Day
                    </a>
                    <a 
                      href="/dashboard"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Dashboard
                    </a>
                    {isAdmin && (
                      <a 
                        href="/admin"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        Admin Dashboard
                      </a>
                    )}
                    <a 
                      href="/help"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Help
                    </a>
                    <button
                      onClick={() => {
                        setIsMenuOpen(false);
                        handleLogout();
                      }}
                    >
                      Logout
                    </button>
                  </>
                )}
                {!isAuthenticated && (
                  <>
                    <a 
                      href="/login"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Login
                    </a>
                    <a 
                      href="/signup"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Sign Up
                    </a>
                    <a 
                      href="/help"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Help
                    </a>
                    <a 
                      href="/contact"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Contact
                    </a>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Layout;